// Local
import { useMediaQuery } from 'shared/hooks/useMediaQuery';
import { mediaQueries } from '@libs/shared-ui-styles';

/**
 * Utility hook returns whether the window's current size should be considered mobile or desktop
 */
export const useIsWindowMobile = () => useMediaQuery(mediaQueries.breakpoints.mobile);
